const checkBackgroundKind = (background) => {
    const VDSBackgroundColors = [
        'lightPrimary',
        'lightSecondary',
        'lightBrandNeutral',
        'darkPrimary',
        'darkSecondary',
        'darkBrandHighlight',
        'limitedRed',
    ];
    const urlPattern = /^(https?:\/\/|www\.|data:image\/)([\w\-./]+)(\.(png|jpg|jpeg|gif|webp|svg|bmp|tiff|ico))?(\?.*)?$/i;
    if (VDSBackgroundColors.includes(background)) {
        return 'tokenColor';
    }
    if (urlPattern.test(background) && background.indexOf('url(') === -1) {
        return 'imageSource';
    }
    return 'custom';
};

export { checkBackgroundKind };
